import * as React from "react"
import qmoLoader from '../scss/img/qmo_loader.gif'
import { CircularProgress, Box } from "@material-ui/core"

interface IProps {
    maxWidth?: number,
    qmoAnimation?: boolean,
    size?: number
}
export default function QmoLoader({ maxWidth, qmoAnimation = false, size = 50 }: IProps) {
    return (
        <Box style={{ width:"100%", textAlign: 'center' }} alignSelf="center">
            {qmoAnimation ?
                <img alt='' style={{ maxWidth: (maxWidth ? maxWidth + 'px' : '270px') }} src={qmoLoader} />
                :
                <CircularProgress size={size}  />
            }

        </Box>)
}
